import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRevisionIndependentGet = {
    path: "/revision/independent/:hash",
    method: RouteHttpVerb.GET
};
export { locationRestRevisionIndependentGet };
